import { render } from "./VisualizedStar.vue?vue&type=template&id=36b991b2&scoped=true"
import script from "./VisualizedStar.vue?vue&type=script&lang=js"
export * from "./VisualizedStar.vue?vue&type=script&lang=js"

import "./VisualizedStar.vue?vue&type=style&index=0&id=36b991b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b991b2"]])

export default __exports__